import ReactDOM from 'react-dom';
import DataObj from '../class/DataObj';

export default class DocumentUtils {
  /**
   * 表格
   * */
  //更新"編輯中"表格時間與時間長度
  static updateInOutHighlight(type, dataObj) {
    let cells = document.getElementsByClassName(
      'htCenter htBottom current highlight'
    );

    if (type === 'In') {
      cells[0].innerHTML = dataObj.In;
    } else {
      cells[0].innerHTML = dataObj.Out;
    }

    //長度
    const Parentelement = cells[0].parentElement;
    Parentelement.children[3].innerHTML = dataObj.Duration;
  }

  /**
   * 拖拉
   * */
  //新增單一拖拉
  // static Add_new_Popup_By_Index(blue_row){
  //
  //     const insertIndex = blue_row ;
  //
  //     var parent = document.getElementById("BalloonView");
  //     var popupObjs = parent.childNodes;
  //
  //     var target = popupObjs[(blue_row)-1];
  //    var newElement = popupObjs[0].cloneNode( true );
  //
  //
  //     newElement.style.left = 0 + "px";
  //     newElement.style.width = 0 + "px";
  //     let targetHeader = newElement.childNodes;
  //     targetHeader[0].innerHTML = "";
  //
  //
  //     parent.insertBefore(newElement, target);
  // }

  //新增十個空的拖拉
  static Add_Emp_Popup() {
    var parent = document.getElementById('BalloonView');
    var popupObjs = parent.childNodes;

    var newElement = popupObjs[0].cloneNode(true);

    newElement.style.left = 0 + 'px';
    newElement.style.width = 0 + 'px';
    let targetHeader = newElement.childNodes;
    targetHeader[0].innerHTML = '';

    parent.appendChild(newElement);
  }

  //移除單一拖拉
  // static RemovePopup_By_Index(deleteRowIndex){
  //     var parent = document.getElementById("BalloonView");
  //     var popupObj = document.getElementById(`popup_${deleteRowIndex}`);
  //     if(popupObj){
  //         parent.removeChild(popupObj);
  //     }
  // }

  //移除表格
  static RemovePopup_mutile_Row(startRow, totlaCount) {
    let parent = document.getElementById('BalloonView');
    for (let i = startRow; i < totlaCount; i++) {
      //移除
      var popupObj = document.getElementById(`popup_${i}`);
      parent.removeChild(popupObj);
    }
  }
  //更新尺寸位置
  static ChangeGraySquareSize(element, d_dataObj) {
    const dataObj = new DataObj(d_dataObj);

    const elementLeft = dataObj.getDragEleLeft();
    const elementWidth = dataObj.getDragEleWidth();
    element.style.left = elementLeft + 'px';
    element.style.width = elementWidth + 'px';
  }

  //更新內文
  static UpdateSpecificGraySquare_text(element, d_dataObj) {
    const dataObj = new DataObj(d_dataObj);
    let target = element.childNodes;
    target[0].innerHTML = dataObj.SubtitleCaption;
  }

  /**
   * 影片
   * */
  //影片播放按鈕更新
  static changePlayerPlayBtn(show) {
    let playBtn = document.getElementById('playBtn');
    let pauseBtn = document.getElementById('pauseBtn');
    if (show === false) {
      //顯示play
      playBtn.style.display = `block`;
      pauseBtn.style.display = `none`;
    } else {
      playBtn.style.display = `none`;
      pauseBtn.style.display = `block`;
    }
  }

  /**
   * 頁面物件
   * */
  //changeSaveBtn
  static changeSaveBtnColor(result) {
    let SaveBtn = document.getElementById('SaveBtn');

    if (result === false) {
      SaveBtn.innerHTML = 'Save';
      SaveBtn.style.backgroundColor = `#767676`;
    } else {
      //有編輯 提醒
      SaveBtn.innerHTML = 'Unsaved';
      SaveBtn.style.backgroundColor = `red`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/helper/DocumentUtils.js